import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import { DatePicker, Select, Input, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Calendar } from '@carbon/icons-react';
import PropTypes from 'prop-types';

class DriverManagementAlertsFilterForm extends Component {
    constructor(props) {
        super(props);
        let currentDriverFilters = null;
        if (props?.driverViewManagementAlertFilters?.length) {
            const matches = props.driverViewManagementAlertFilters.filter(f => parseInt(f.driverId) === parseInt(props.driverId));
            if (matches?.length) {
                currentDriverFilters = matches[0]?.filters;
            }
        }
        this.state = { currentDriverFilters };
    }

    componentDidUpdate(prevProps) {
        const { driverViewManagementAlertFilters, driverId } = this.props;
        
        if (prevProps.driverViewManagementAlertFilters !== driverViewManagementAlertFilters) {
            let currentDriverFilters = null;
            if (driverViewManagementAlertFilters?.length) {
                const matches = driverViewManagementAlertFilters.filter(f => parseInt(f.driverId) === parseInt(driverId));
                if (matches?.length) {
                    currentDriverFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentDriverFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit } = this.props;
        
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form } = this.props;
        const { currentDriverFilters } = this.state;
        
        const { getFieldDecorator } = form;

        return (
            <Form 
                onSubmit={this.submitForm} 
                layout="vertical"
            >
                <Form.Item label="Name">
                    {getFieldDecorator('alert_name', { initialValue: currentDriverFilters?.alert_name || null })(
                        <Input 
                            placeholder="Enter Name" 
                            data-testid='driver-details-service-alert-filter_name-input'
                        />
                    )}
                </Form.Item>
                <Form.Item label="Description">
                    {getFieldDecorator('alert_description', { initialValue: currentDriverFilters?.alert_description || null })(
                        <Input 
                            placeholder="Enter Description" 
                            data-testid='driver-details-service-alert-filter_description-input'
                        />
                    )}
                </Form.Item>
                <Form.Item label="Alert frequency">
                    {getFieldDecorator('frequency', { initialValue: currentDriverFilters?.frequency || null})(
                        <Select
                            placeholder="Select Frequency"
                            data-testid='driver-details-service-alert-filter_frequency-select'
                        >
                            <Select.Option value="2">Monthly</Select.Option>
                            <Select.Option value="1">Quarterly</Select.Option>
                            <Select.Option value="0">Yearly</Select.Option>
                        </Select>,
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                        data-testid='driver-details-service-alert-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const DriverManagementAlertsFilter = Form.create({ name: 'event_filter_form' })(DriverManagementAlertsFilterForm);

DriverManagementAlertsFilterForm.propTypes = {
    driverViewManagementAlertFilters: PropTypes.object,
    driverId: PropTypes.number,
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        driverViewManagementAlertFilters: state.driver.driverViewManagementAlertFilters
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverManagementAlertsFilter);
